import { P } from '@ahmdigital/ui';

const RequiredFieldsDisclaimer = () => <P>All fields marked with * are required</P>;

export default RequiredFieldsDisclaimer;
